"use client";

import AmbientCanvas from "./AmbientCanvas";

const creed = [
  "We do not chase the light.",
  "We are the reason it lingers.",
];

const stats = [
  { value: "47", label: "Rare Ingredients" },
  { value: "6mo", label: "Per Blend" },
  { value: "24k", label: "Gold Crest" },
  { value: "12h+", label: "Longevity" },
];

export default function Manifesto() {
  return (
    <section
      id="creed"
      aria-label="The Stygian Creed"
      className="relative py-20 md:py-28 overflow-hidden"
      style={{ background: "linear-gradient(180deg, #fbf8f2 0%, #f4efe6 100%)" }}
    >
      {/* Radiant light glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 55% 45% at 50% 50%, rgba(201,168,76,0.1) 0%, transparent 70%)",
        }}
      />

      <AmbientCanvas variant="luxury" accent="#a8843a" density={0.4} className="opacity-35" />

      {/* Ornate frame corners */}
      <div className="absolute inset-6 md:inset-12 pointer-events-none" aria-hidden="true">
        <div className="absolute top-0 left-0 w-10 md:w-16 h-10 md:h-16 border-t border-l border-[#c9a84c]/40" />
        <div className="absolute top-0 right-0 w-10 md:w-16 h-10 md:h-16 border-t border-r border-[#c9a84c]/40" />
        <div className="absolute bottom-0 left-0 w-10 md:w-16 h-10 md:h-16 border-b border-l border-[#c9a84c]/40" />
        <div className="absolute bottom-0 right-0 w-10 md:w-16 h-10 md:h-16 border-b border-r border-[#c9a84c]/40" />
      </div>

      {/* Vertical hairline */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3" aria-hidden="true">
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-[#c9a84c]/40 to-[#c9a84c]/30" />
        <div className="w-1 h-1 rotate-45 bg-[#c9a84c]/50" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        {/* Eyebrow */}
        <p className="reveal-blur text-[10px] tracking-[0.5em] uppercase text-[#8a6a2c]/70 mb-10">
          &mdash; The Stygian Creed &mdash;
        </p>

        {/* Statement — slides in from opposite directions */}
        <div className="manifesto-statement">
          <p
            className="reveal-left font-serif text-3xl sm:text-4xl md:text-6xl lg:text-7xl leading-[1.15] tracking-tight text-[#221d17]/90"
            style={{ fontWeight: 200 }}
          >
            {creed[0]}
          </p>
          <p
            className="reveal-right font-serif text-3xl sm:text-4xl md:text-6xl lg:text-7xl leading-[1.15] tracking-tight"
            style={{ fontWeight: 200 }}
          >
            <span className="text-shimmer-gold">{creed[1]}</span>
          </p>

          {/* Divider */}
          <div className="flex items-center justify-center gap-4 mt-12" aria-hidden="true">
            <div className="w-16 h-px bg-gradient-to-r from-transparent to-[#c9a84c]/60" />
            <div className="w-1.5 h-1.5 rotate-45 border border-[#c9a84c]/70" />
            <div className="w-16 h-px bg-gradient-to-l from-transparent to-[#c9a84c]/60" />
          </div>
        </div>

        {/* Stats */}
        <div className="reveal-blur mt-16" style={{ transitionDelay: "0.2s" }}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
            {stats.map((stat) => (
              <div key={stat.label} className="flex flex-col items-center gap-2">
                <span className="font-serif text-4xl md:text-5xl text-[#a8843a]/80">
                  {stat.value}
                </span>
                <span className="text-[8px] tracking-[0.3em] uppercase text-[#6f6759]/60">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}